import api from './api';

class CoursesApi {
    static async getCustomerCourses(customerId) {
        return api.request({
            method: 'GET',
            url: `/course/customer-course?customerId=${customerId}&clinic=all&excludeExpired=false`
        });
    }

    static async verifyCourseAssignment(invoiceId) {
        return api.request({
            method: 'POST',
            url: `/course/verify-assignment/${invoiceId}`
        });
    }

    static async getCourse(courseId) {
        return api
            .request({
                method: 'GET',
                url: `/course/withoutAppt/${courseId}`
            })
            .then(res => res)
            .catch(console.error);
    }
}

export default CoursesApi;
